import { useCodeiumCommand } from "commands/definitions/settings/useCodeiumCommand";
import { useColorSchemaCommand } from "commands/definitions/settings/useColorSchemaCommand";
import { useEnvironmentVariablesCommand } from "commands/definitions/settings/useEnvironmentVariablesCommand";
import { useProjectSettingsCommand } from "commands/definitions/settings/useProjectSettingsCommand";
import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";
import { useEditor } from "features/editor/Feature";

export const useRegisterSettingsCommands = () => {
  const { allowedCapabilities, aiConsent } = useEditor();
  // Themes
  const switchThemeCommand = useColorSchemaCommand();
  const openProjectSettingsCommand = useProjectSettingsCommand();
  const openEnvironmentVariablesCommand = useEnvironmentVariablesCommand();
  const codeiumCommand = useCodeiumCommand();

  // General and preferences
  const commands = [openProjectSettingsCommand, switchThemeCommand];
  if (allowedCapabilities.secrets) {
    commands.push(openEnvironmentVariablesCommand);
  }

  if (aiConsent) {
    commands.push(codeiumCommand);
  }

  useRegisterCommands(commands, [switchThemeCommand, aiConsent]);
};
